import { render, staticRenderFns } from "./OrdersOrder.vue?vue&type=template&id=34dadc93&scoped=true&"
import script from "./OrdersOrder.vue?vue&type=script&lang=js&"
export * from "./OrdersOrder.vue?vue&type=script&lang=js&"
import style0 from "./OrdersOrder.vue?vue&type=style&index=0&id=34dadc93&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34dadc93",
  null
  
)

export default component.exports